export default "__VITE_ASSET__jNHaQD3j__"